// import "@fortawesome/fontawesome-pro/css/all.css";

import 'bootstrap';

import 'lightgallery/src/sass/lightgallery.scss';

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';

import Instafeed from 'instafeed.js';

window.Instafeed = Instafeed;

import {Carousel} from "./blocks/carousel";
import {IndustrySlider} from "./blocks/industry-slider";
import {TrustmarkedProductsSlider} from "./blocks/trustmarked-products-slider";
import {NewsSlider} from "./blocks/news-slider";
import "./post-filter";
import "./oritain-blog-filter";
import {VerificationProcessSlider} from "./blocks/verification-process-slider";
import {ResourceSlider} from "./blocks/resource-slider";
import formDownload from './blocks/form-download';

import mobileNav from "./header/mobile-nav";

import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';


import Hotjar from '@hotjar/browser';
import {LinksSlider} from "./blocks/links-slider";
import {CustomerLogos} from "./blocks/customer-logos";
import {TestimonialsSlider} from "./blocks/testimonials-slider";
import {PartnersSlider} from "./blocks/partners-slider";

const siteId = 3595418;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);

function setCookie(cname, cvalue, exdays) {
    var expires = "expires=0";
    if (exdays !== 0) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = "expires=" + d.toUTCString();
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function showPopup() {
    var popup = getCookie("shownPopup");
    if (popup === '') {
        $("#popupMessage").removeClass("d-none");
    } else {
        $("#popupMessage").addClass("d-none");
    }
}

$(function () {

    Carousel();
    CustomerLogos();
    TestimonialsSlider();
    IndustrySlider();
    LinksSlider();
    TrustmarkedProductsSlider();
    PartnersSlider();
    NewsSlider();
    VerificationProcessSlider();
    mobileNav();
    basicNavigation();
    ResourceSlider();
    formDownload();

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });

    $('.to-top').on('click', function (event) {
        event.preventDefault();
        $('html, body').animate({scrollTop: 0}, 500, 'swing');
        return false;
    });

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');

});

$("#ClosePopUp").click(function () {
    $("#popupMessage").addClass("d-none");
    var popupBehaviour = $('#popupMessage').attr('data-close-type');
    var popup = getCookie("shownPopup");
    if (popupBehaviour === 'PerSession' && popup === '') {
        setCookie('shownPopup', true, 0);
        return false;
    }
});

$(window).on('load', function () {

    showPopup();


    var description = $(".SVGMapDescription");

    $('.map-image g.markers path').hover(function () {
        description.addClass('active');
        description.html($(this).attr('data-country'));
        $('.SVGMapDescriptionLoad').css('display', 'none');
    }, function () {
        description.removeClass('active');
    });
    $(document).on('mousemove', function (e) {
        description.css({
            left: e.pageX,
            top: e.pageY
        });
    });
});

if ($('#readingTime').length > 0) {
    const text = $('.OritainBlogPost .content-container').text();
    const wpm = 225;
    const words = text.trim().split(/\s+/).length;
    const time = Math.ceil(words / wpm);
    document.getElementById("readingTime").innerText = time;
}

$(document).ready(function () {
    $('.ytlazy').on("click", function () {
        let videoid = $(this).attr('data-src');
        let iframe = $('<iframe>', {
            src: 'https://www.youtube.com/embed/' + videoid + '?rel=0&showinfo=0&autoplay=1&modestbranding=1',
            allow: 'autoplay',
            allowFullScreen: true,
            frameBorder: 0
        });
        $(this).html(iframe);
    });
    console.log('start')
    if($('.CaseStudyPage').length > 0){
        console.log('inside')
        const caseStudyCheckmarkSection = $('.case-study-checkmark-section');
        console.log(caseStudyCheckmarkSection)
        if(!caseStudyCheckmarkSection.hasClass('checkmark-position-bottom')){
            let statElement = $('.elemental-stats');
            console.log(statElement);
            if(statElement){
                if(caseStudyCheckmarkSection.hasClass('checkmark-position-above')){
                    caseStudyCheckmarkSection.insertBefore(statElement);
                } else {
                    caseStudyCheckmarkSection.insertAfter(statElement);
                }
            }
        }
        caseStudyCheckmarkSection.removeClass('d-none')
    }
})




